<template>
  <div class="statistics-training">
    <div class="hd ly-card">
      <el-select class="m-r-10" v-model="searchFormData.year" placeholder="学年">
        <el-option v-for="item in years" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <el-select class="m-r-10" v-model="searchFormData.term" placeholder="学期">
        <el-option v-for="item in terms" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <el-input class="m-r-10" style="width: 220px" clearable v-model.trim="searchFormData.query" placeholder="教师姓名"></el-input>
      <el-button @click="search" size="medium" type="primary">查询</el-button>
      <el-button size="medium" type="primary" @click="exportExcel">导出</el-button>
    </div>
    <div class="ly-card" v-loading="loading">
      <table class="native-table">
        <tr>
          <th>教师姓名</th>
          <th>总学费</th>
          <th>总报名人数</th>
          <th>总课次</th>
          <th>平均报名率</th>
          <th>平均退课率</th>
          <th>班级名称</th>
          <th>班课次</th>
          <th>课程安排</th>
          <th>班报名人数</th>
          <th>班学费</th>
          <th>班报名率</th>
          <th>班退费率</th>
        </tr>
        <template v-for="item in getTableData">
          <tr v-for="(curItem, index) in item.class_obj_list" :key="`index/${curItem.id}`">
            <td v-if="index === 0" :rowspan="item.rowspan">
              {{ item.real_name }}
            </td>
            <td v-if="index === 0" :rowspan="item.rowspan">
              {{ item.total_class_fee }}
            </td>
            <td v-if="index === 0" :rowspan="item.rowspan">
              {{ item.total_sign_up_count }}
            </td>
            <td v-if="index === 0" :rowspan="item.rowspan">
              {{ item.total_courses_count }}
            </td>
            <td v-if="index === 0" :rowspan="item.rowspan">
                {{ item.average_registration_rate }}
            </td>
            <td v-if="index === 0" :rowspan="item.rowspan">
                {{ item.average_refund_rate }}
            </td>
            <td>{{ curItem.name }}</td>
            <td>{{ curItem.courses_count }}</td>
            <td>
              <div v-html="classTimeSp(curItem)"></div>
            </td>
            <td>{{ curItem.real_sign_up_count }}</td>

            <td>{{ curItem.class_fee }}</td>
            <td>{{ curItem.registration_rate }}</td>
            <td>{{ curItem.refund_rate }}</td>
          </tr>
        </template>
      </table>
      <el-pagination
        class='ly-pagination'
        @size-change="handlePageChange"
        @current-change="handleCurrentChange"
        layout="prev, pager, next, -> ,sizes, total"
        :total="this.total"
        :page-sizes="[pageSize,pageSize*2,pageSize*3,pageSize*10]"
      />
    </div>
  </div>
</template>

<script>
import { Option, Input, Select, Pagination } from 'element-ui';
import { report } from '@/api';
import utils from '@/utils/utils';
import enterMixin from '@/utils/enterMixin';

export default {
  name: 'SalaryManage',
  mixins: [enterMixin],
  components: {
    ElInput: Input,
    ElSelect: Select,
    ElOption: Option,
    ElPagination: Pagination
  },
  data() {
    return {
      loading: true,
      searchFormData: {
        year: `${new Date().getFullYear()}`,
        term: '',
        query: '',
        page_no: 1,
        page_size: 10
      },
      total: 0,
      pageSize: 10,
      getTableData: {},
      years: [],
      terms: []
    };
  },
  mounted() {
    this.$store.dispatch('schoolYear/getTermAndYearList').then(data => {
      if (data) {
        this.years = data.year;
        this.terms = data.term;
        this.searchFormData.term = data.term[0].value;
        this.search();
      }
    });
  },
  methods: {
    handleCurrentChange(page) {
      this.searchFormData.page_no = page;
      this.search();
    },
    handlePageChange(pageSize) {
      this.searchFormData.page_size = pageSize;
      this.searchFormData.page_no = 1;
      this.search();
    },
    search() {
      this.loading = true;
      const temp = { ...this.searchFormData };
      Object.keys(temp).forEach(key => {
        const value = temp[key];
        if (value && value !== -1) temp[key] = value;
        else delete temp[key];
      });
      report.getTrainingStatistics(temp).then(res => {
        if (res) {
          this.getTableData = res.data.teacher_list;
          this.total = res.data.total;
        }
        this.loading = false;
      });
    },
    async reset() {
      this.$refs.lyForm.resetFields();
      const data = {};
      Object.keys(this.formKeys).map(key => {
        if (key) data[key] = '';
        return key;
      });
      this.$emit('search', data);
    },
    pageChange({ page_size, page_no }) {
      this.paginConfig.page_no = page_no;
      this.paginConfig.page_size = page_size;
      this.search();
    },
    exportExcel() {
      const params = { ...this.searchFormData };
      Object.keys(params).forEach(key => {
        if (params[key] === '' || params[key] === null) delete params[key];
      });
      report
        .exportBackStudyRate({
          params
        })
        .then(data => {
          if (data) utils.downloadData(data, '教师培训统计');
        });
    }
  }
};
</script>

<style lang="less">
.statistics-training {
  .el-select {
    width: 160px;
  }
  .ly-search-comp {
    display: inline-block;
    width: 180px;
    .el-select {
      width: 100%;
    }
  }
  .el-input {
    width: 100%;
    height:36px;
    line-height: 36px;
    input{
      height:36px;
      line-height: 36px;
    }
  }
  > * {
    margin: 0 10px;
  }
  .ly-pagination {
    text-align: center;
    margin-top: 10px;
  }
}
</style>
